type LocationObj = {
  pathname: string
  state?: {[key: string]: any}
  [key: string]: any
}

type RouteContextObj = {
  appPath: string
}

export type RouteContext = RouteContextObj | string
export type Location = LocationObj | string

export function parseLocation(location: Location) {
  if (!location) {
    // go no where
    return
  }

  const currentUrlState = {prevUrl: window.location.href}

  if (typeof location === "string") {
    const [url, search] = location.split("?")
    return {pathname: url, search, state: {...currentUrlState}}
  }

  if (!location.pathname) {
    return
  }

  // strip any circlular refs + functions from state as browserHistory will fail on this
  const state: {[key: string]: any} = JSON.parse(
    JSON.stringify({
      ...currentUrlState,
      ...(location.state || {})
    })
  )

  let pathname = location.pathname
  let search = location.search
  if (!search) {
    ;[pathname, search] = location.pathname.split("?")
  }

  return {
    ...location,
    pathname,
    search,
    state
  }
}

export function addContext(location: Location, context: RouteContext): Location {
  let url = typeof context === "string" ? context : context.appPath
  if (url === "/") {
    url = ""
  }
  if (typeof location === "string") {
    return `${url}${location.replace(/^[/]*/, "/")}`
  } else if (location) {
    const pathname = addContext(location.pathname, url) as string
    return {...location, pathname}
  } else {
    return ""
  }
}

export function appOrContext({to, app}: {to: string; app: string}, context: RouteContext) {
  if (app) {
    return addContext(to, app)
  }
  return addContext(to, context)
}
